import { render, staticRenderFns } from "./goodTypeManage.vue?vue&type=template&id=3b3d6e2e&"
import script from "./goodTypeManage.vue?vue&type=script&lang=js&"
export * from "./goodTypeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports